export const verifyEmailStepFormStyle = theme => ({
  root: {
    width: '100%',
  },
})
